// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"8cf6e2f4","147":"da20f55f","243":"0dde60c4","361":"914f4e9a","418":"dce5c1db","451":"71effee3","478":"0d0450c2","524":"3aab19c1","938":"c0835afa","976":"3953c858","981":"a48e8dc5"}[chunkId] + ".chunk.js";
};